import SideNavbar from "../../../components/SideNavbar"
import { useAppSelector } from "../../../redux/store"
import { useNavigate } from "react-router-dom"
import React from "react"

// Icons to represent integrations
const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 text-blue-600">
    <path d="M12 2.04c-5.5 0-10 4.49-10 10.02 0 5 3.66 9.15 8.44 9.9v-7H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.89 3.78-3.89 1.09 0 2.23.19 2.23.19v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.45 2.9h-2.33v7a10 10 0 0 0 8.44-9.9c0-5.53-4.5-10.02-10-10.02z" />
  </svg>
)

const WhatsAppIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 text-green-500">
    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.188 8.188 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.82-.78.99-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01" />
  </svg>
)

const GoogleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 48 48">
    <path fill="#f5bc00" d="M43.6,20.1H42V20H24v8h11.3c-1.6,4.7-6.1,8-11.3,8c-6.6,0-12-5.4-12-12s5.4-12,12-12c3.1,0,5.8,1.2,8,3l5.7-5.7 C34,6.1,29.3,4,24,4C13,4,4,13,4,24s9,20,20,20s20-9,20-20C44,22.7,43.9,21.4,43.6,20.1z"></path><path fill="#6c19ff" d="M43.6,20.1L43.6,20.1L42,20H24v8h11.3c-0.8,2.2-2.2,4.2-4.1,5.6c0,0,0,0,0,0l6.2,5.2C37,39.2,44,34,44,24 C44,22.7,43.9,21.4,43.6,20.1z"></path><path fill="#3ddab4" d="M24,44c5.2,0,9.9-2,13.4-5.2l-6.2-5.2c-2,1.5-4.5,2.4-7.2,2.4c-5.2,0-9.6-3.3-11.3-7.9l-6.5,5 C9.5,39.6,16.2,44,24,44z"></path><path fill="#f55376" d="M6.3,14.7l6.6,4.8C14.7,15.1,19,12,24,12c3.1,0,5.8,1.2,8,3l5.7-5.7C34,6.1,29.3,4,24,4 C16.3,4,9.7,8.3,6.3,14.7z"></path><path fill="#2100c4" d="M26.6,35.7l6.8,6c1.5-0.8,2.9-1.8,4.1-2.9l-6.2-5.2C29.9,34.6,28.3,35.3,26.6,35.7z"></path><path fill="#eb0000" d="M9.2,10.6c-1.1,1.2-2.1,2.6-2.9,4.1l3.9,2.9l2.6,1.9c0.6-1.6,1.6-3,2.8-4.1L9.2,10.6z"></path>
  </svg>
)

const GmailIcon = () => (
  <img src="/images/desktop/gmailIcon.svg" alt="Gmail" className="w-8 h-8" />
)

const WebhookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 48 48">
    <path fill="#37474f" d="M35,37c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S37.2,37,35,37z"></path><path fill="#37474f" d="M35,43c-3,0-5.9-1.4-7.8-3.7l3.1-2.5c1.1,1.4,2.9,2.3,4.7,2.3c3.3,0,6-2.7,6-6s-2.7-6-6-6 c-1,0-2,0.3-2.9,0.7l-1.7,1L23.3,16l3.5-1.9l5.3,9.4c1-0.3,2-0.5,3-0.5c5.5,0,10,4.5,10,10S40.5,43,35,43z"></path><path fill="#37474f" d="M14,43C8.5,43,4,38.5,4,33c0-4.6,3.1-8.5,7.5-9.7l1,3.9C9.9,27.9,8,30.3,8,33c0,3.3,2.7,6,6,6 s6-2.7,6-6v-2h15v4H23.8C22.9,39.6,18.8,43,14,43z"></path><path fill="#e91e63" d="M14,37c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S16.2,37,14,37z"></path><path fill="#37474f" d="M25,19c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S27.2,19,25,19z"></path><path fill="#e91e63" d="M15.7,34L12.3,32l5.9-9.7c-2-1.9-3.2-4.5-3.2-7.3c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10 c0,0.9-0.1,1.7-0.3,2.5l-3.9-1c0.1-0.5,0.2-1,0.2-1.5c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,2.1,1.1,4,2.9,5.1l1.7,1L15.7,34z"></path>
  </svg>
)

const CloudTelephonyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"> 
    <path opacity="0.5" d="M15.5562 14.5477L15.1007 15.0272C15.1007 15.0272 14.0181 16.167 11.0631 13.0559C8.10812 9.94484 9.1907 8.80507 9.1907 8.80507L9.47752 8.50311C10.1841 7.75924 10.2507 6.56497 9.63424 5.6931L8.37326 3.90961C7.61028 2.8305 6.13596 2.68795 5.26145 3.60864L3.69185 5.26114C3.25823 5.71766 2.96765 6.30945 3.00289 6.96594C3.09304 8.64546 3.81071 12.259 7.81536 16.4752C12.0621 20.9462 16.0468 21.1239 17.6763 20.9631C18.1917 20.9122 18.6399 20.6343 19.0011 20.254L20.4217 18.7584C21.3806 17.7489 21.1102 16.0182 19.8833 15.312L17.9728 14.2123C17.1672 13.7486 16.1858 13.8848 15.5562 14.5477Z" fill="#00cc33"></path>
  </svg>
)

interface IntegrationCardProps {
  title: string
  description: string
  icon: React.ReactNode
  status: "available" | "coming-soon" | "on-request"
  onClick?: () => void
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({ 
  title, 
  description,
  icon,
  status,
  onClick
}) => {
  const isAvailable = status === "available"
  
  return (
    <div 
      className={`
        relative p-6 rounded-xl shadow-md transition-all duration-300
        ${isAvailable 
          ? "bg-white border border-gray-200 hover:shadow-lg cursor-pointer" 
          : "bg-gray-100 border border-gray-200 cursor-not-allowed"}
      `}
      onClick={isAvailable ? onClick : undefined}
    >
      {status === "coming-soon" && (
        <div className="absolute top-3 right-3 bg-amber-100 text-amber-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
          Coming Soon
        </div>
      )}
      {status === "on-request" && (
        <div className="absolute top-3 right-3 bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
          On Request
        </div>
      )}
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 mt-1">
          {icon}
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-1">{title}</h3>
          <p className="text-sm text-gray-600">{description}</p>
        </div>
      </div>
    </div>
  )
}

const Integrations: React.FC = () => {
    const isCollapsed = useAppSelector((state) => state.sidebar.isCollapsed);
    const navigate = useNavigate();

    const handleMetaAdsClick = () => {
      navigate("/integrations/meta-ads");
    };
    
    const handleGoogleAdsClick = () => {
      navigate("/integrations/google-ads");
    };

    return (
        <div className="min-h-screen bg-gray-200">
            <div className="fixed top-16 left-0 h-full z-10">
                <SideNavbar />
            </div>

            <div className={`${isCollapsed ? 'ml-[70px]' : 'ml-[290px]'} mt-[109px] p-8 transition-all duration-300`}>
                <div className="bg-white p-8 rounded-3xl shadow-md">
                    <div className="mb-8">
                        <h1 className="text-2xl font-bold text-gray-900">Integrations</h1>
                        <p className="text-gray-600 mt-2">Connect your CRM with other platforms to enhance your workflow</p>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <IntegrationCard
                          title="Meta Ads Integration"
                          description="Connect your Meta Ads account to track and manage your ad campaigns directly from your CRM"
                          icon={<FacebookIcon />}
                          status="available"
                          onClick={handleMetaAdsClick}
                        />
                        
                        <IntegrationCard
                          title="WhatsApp Business Cloud Integration"
                          description="Send messages and notifications to your leads and clients via WhatsApp Business API"
                          icon={<WhatsAppIcon />}
                          status="available"
                          onClick={() => navigate("/integrations/whatsapp-business-cloud")}
                        />
                        
                        <IntegrationCard
                          title="Google Ads Integration"
                          description="Connect your Google Ads account to track and optimize your advertising campaigns in your CRM"
                          icon={<GoogleIcon />}
                          status="on-request"
                          onClick={handleGoogleAdsClick}
                        />
                        <IntegrationCard
                          title="Webhook Integration"
                          description="Connect your Webhook with the ScholarCRM to receive and add leads in real-time"
                          icon={<WebhookIcon />}
                          status="available"
                          onClick={() => navigate("/integrations/webhooks")}
                        />
                        <IntegrationCard
                          title="Cloud Telephony Integration"
                          description="Integrate with cloud telephony providers like Exotel and Vox Bay for advanced calling features."
                          icon={<CloudTelephonyIcon />}
                          status="available"
                          onClick={() => navigate("/integrations/cloud-telephony")}
                        />
                        <IntegrationCard
                          title="Gmail Integration"
                          description="Connect your Gmail account to send single or bulk emails to your leads and clients directly from the CRM"
                          icon={<GmailIcon />}
                          status="available"
                          onClick={() => navigate("/integrations/gmail")}
                        />
                    </div>
                </div>
            </div>
        </div>
  );
};

export default Integrations;